export const bidsKeys = {
  all: () => ["bids"] as const,
  lists: () => [...bidsKeys.all(), "list"] as const,
  list: (params?: string) => [...bidsKeys.lists(), params] as const,
  details: () => [...bidsKeys.all(), "details"] as const,
  detail: (id: string) => [...bidsKeys.details(), id] as const,
};

export const groupsKeys = {
  all: () => ["groups"] as const,
  lists: () => [...groupsKeys.all(), "list"] as const,
  list: (params?: string) => [...groupsKeys.lists(), params] as const,
  details: () => [...groupsKeys.all(), "details"] as const,
  detail: (id: string) => [...groupsKeys.details(), id] as const,
  offices: (groupId: string, params?: string) => [...groupsKeys.detail(groupId), "offices", params] as const,
};

export const mandatesKeys = {
  all: () => ["mandates"] as const,
  lists: () => [...mandatesKeys.all(), "list"] as const,
  list: (params?: string) => [...mandatesKeys.lists(), params] as const,
  details: () => [...mandatesKeys.all(), "details"] as const,
  detail: (id: string) => [...mandatesKeys.details(), id] as const,
};

export const companiesKeys = {
  all: () => ["companies"] as const,
  lists: () => [...groupsKeys.all(), "list"] as const,
  list: (id: string, params?: object) => [...groupsKeys.lists(), id, params] as const,
  details: () => [...groupsKeys.all(), "details"] as const,
  detail: (id: string) => [...groupsKeys.details(), id] as const,
};

export const partnersKeys = {
  all: () => ["partners"] as const,
  lists: () => [...partnersKeys.all(), "list"] as const,
  list: (params?: object) => [...partnersKeys.lists(), params] as const,
  details: () => [...partnersKeys.all(), "details"] as const,
  detail: (id?: number) => [...partnersKeys.details(), id] as const,
};

export const partnerRequestsKeys = {
  all: () => ["partner-requests"] as const,
  lists: () => [...partnerRequestsKeys.all(), "list"] as const,
  listActivity: (activityId?: number) => [...partnerRequestsKeys.lists(), "activity", activityId] as const,
  listSubOrders: (partnerRequestId?: number) => [...partnerRequestsKeys.lists(), "sub-orders", partnerRequestId] as const,
  details: () => [...partnerRequestsKeys.all(), "details"] as const,
  detail: (id?: number) => [...partnerRequestsKeys.details(), id] as const,
};

export const officesKeys = {
  all: () => ["offices"] as const,
  lists: () => [...officesKeys.all(), "list"] as const,
  list: (group_id: number) => [...officesKeys.lists(), group_id] as const,
};

export const documentsKeys = {
  all: () => ["documents"] as const,
  lists: () => [...documentsKeys.all(), "list"] as const,
  list: (params?: object) => [...documentsKeys.lists(), params] as const,
};

export const contactsKeys = {
  all: () => ["contacts"] as const,
  details: () => [...contactsKeys.all(), "details"] as const,
  detail: (id?: number) => [...contactsKeys.details(), id] as const,
};
